import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'viassistAllowedHtml', standalone: true })
export class ViassistAllowedHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  public transform(value: string, tags: string[] = ['header', 'footer']): SafeHtml {
    if (!value) {
      return '';
    }

    const doc: Document = new DOMParser().parseFromString(value, 'text/html');

    // remove header and footer tags
    tags.forEach((tag: string) => {
      const elements: NodeListOf<Element> = doc.querySelectorAll(tag);
      elements.forEach((el) => el.parentNode?.removeChild(el));
    });

    // wrap tables with div.table-responsive
    const tables: NodeListOf<HTMLTableElement> = doc.querySelectorAll('table');
    tables.forEach((table) => {
      const wrapper = doc.createElement('div');
      wrapper.className = 'table-responsive';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });

    // disable all links
    const links: NodeListOf<HTMLAnchorElement> = doc.querySelectorAll('a');
    links.forEach((link) => {
      if (!link.href.startsWith('https://live.viessmann-climatesolutions.com')) {
        link.href = '#';
        link.className = 'disabled';
      }
    });

    // remove section with attachments
    const sections: NodeListOf<HTMLElement> = doc.querySelectorAll('section');
    sections.forEach((section: HTMLElement) => {
      if (section.className === 'attachments') {
        section.parentNode?.removeChild(section);
      }
    });

    const cleanHtml = doc.body.innerHTML; // This is the HTML string without the specified tags

    return this.sanitizer.bypassSecurityTrustHtml(cleanHtml) || '';
  }
}
